/**
 * Web entry: react-native-web AppRegistry (не используем Expo export).
 * webrtc-adapter — полифиллы RTCPeerConnection для Safari и старых Chromium.
 */
import 'webrtc-adapter';
import 'react-native-gesture-handler';
import './src/notifications/fcmBackground';
import { installStaleChunkRecovery } from './src/web/recoverFromStaleChunks';
import { AppRegistry } from 'react-native';
import App from './App';

AppRegistry.registerComponent('main', () => App);

// До первого ленивого импорта: вкладка, открытая до выкатки, просит куски со старыми
// хешами, и первая же подгрузка (в том числе экрана звонка) падает ChunkLoadError.
installStaleChunkRecovery();

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root');
}

/**
 * Снятие стартовой HTML-заглушки (#boot-splash из index.html). Идемпотентно и
 * не бросает: заглушки может уже не быть, а ронять из-за неё загрузку нельзя.
 * Публикуем на window, потому что вызывать нас будет ещё и React-компонент
 * BootSplash при монтировании — он рисует ровно такую же плашку, и снять
 * HTML-слой ровно в этот момент = переход без мигания.
 */
function hideBootSplash(): void {
  try {
    // Сторож из index.html больше не нужен: заглушку снимаем сами и по делу.
    if (typeof window.__vrmBootSplashWatchdog === 'number') {
      window.clearTimeout(window.__vrmBootSplashWatchdog);
      window.__vrmBootSplashWatchdog = undefined;
    }
    const el = document.getElementById('boot-splash');
    if (!el) return;
    el.classList.add('is-hidden');
    window.setTimeout(() => {
      el.remove();
    }, 300);
  } catch (_) {
    /* заглушка не наш критичный путь — молча идём дальше. */
  }
}

window.__vrmHideBootSplash = hideBootSplash;

AppRegistry.runApplication('main', {
  rootTag: root,
  initialProps: {},
});

/**
 * Вторая точка снятия — по ФАКТУ отрисовки, а не по числу кадров. Основная всё равно
 * BootSplash (`ready` в AuthProvider стартует с false, так что он монтируется всегда), но
 * runApplication в RNW 0.21 рендерит через конкурентный createRoot: начальный рендер может
 * прерываться планировщиком, и два кадра (~32 мс) на слабом устройстве наступают раньше
 * первой отрисовки — заглушка успела бы погаснуть до того, как React что-то нарисовал, и
 * пользователь увидел бы ровно то мигание, от которого мы уходим. Потолок в 5 с — чтобы
 * интервал не жил вечно; дальше отрабатывает сторож из index.html.
 */
const PAINT_POLL_MS = 50;
const PAINT_POLL_LIMIT_MS = 5000;
let paintWaited = 0;
const paintPoll = window.setInterval(() => {
  paintWaited += PAINT_POLL_MS;
  if (root.firstChild) {
    window.clearInterval(paintPoll);
    hideBootSplash();
    return;
  }
  if (paintWaited >= PAINT_POLL_LIMIT_MS) window.clearInterval(paintPoll);
}, PAINT_POLL_MS);

declare global {
  interface Window {
    __VRM_ICE_SERVERS__?: unknown;
    __vrmHideBootSplash?: () => void;
    /** id сторожевого таймера из index.html; гасим его, когда снимаем заглушку сами. */
    __vrmBootSplashWatchdog?: number;
  }
}
